var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-view"},[_c('div',{staticClass:"c-view__two",class:{ active: _vm.view === 2 },on:{"click":function($event){return _vm.setView(2)}}}),_c('div',{staticClass:"c-view__four",class:{ active: _vm.view === 4 },on:{"click":function($event){return _vm.setView(4)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }